import { configureStore,combineReducers } from '@reduxjs/toolkit'
import loaderReducer from '../slice/loader.slice';
import authReducer from '../slice/authSlice';
import imageThumbReducer from "../slice/imagethumb.slice";

import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER, } from 'redux-persist';
import thunk from 'redux-thunk';


const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const reducers = combineReducers({
  loader: loaderReducer,
  auth : authReducer,
  imageThumbSlice : imageThumbReducer,
})

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer:persistedReducer,
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
      serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
  }),
  devTools: process.env.NODE_ENV !== 'production',
})

export let persister = persistStore(store);
